import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import { motion, useAnimationControls } from "framer-motion";
import type React from "react";
import { useEffect } from "react";

type Props = {
	selectedNurseForPto: unknown;
	/**
	 * This will re-trigger the animation
	 */
	triggerKey: number | string;
	handleAddIconClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export function AddPtoButtonRattle({ selectedNurseForPto, triggerKey, handleAddIconClick }: Props) {
	const controls = useAnimationControls();
	const isDisabled = !selectedNurseForPto;

	useEffect(() => {
		if (isDisabled) return;

		controls.start({
			x: [0, -3, 0, 3, 0],
			y: [0, -3, 0, -3, 0],
			transition: {
				duration: 0.7, // total cycle length
				ease: "easeInOut",
				times: [0, 0.25, 0.5, 0.75, 1],
				repeat: Infinity,
			},
		});

		// Stop after 2 seconds
		const timeout = setTimeout(() => {
			controls.start({ x: 0, rotate: 0, y: 0 });
		}, 2000);

		return () => clearTimeout(timeout);
	}, [triggerKey, isDisabled, controls]);

	return (
		<motion.div
			animate={controls}
			style={{
				display: "inline-flex",
				transformOrigin: "center center",
			}}
		>
			<IconButton disabled={isDisabled} onClick={handleAddIconClick}>
				<AddIcon />
			</IconButton>
		</motion.div>
	);
}
